import React from "react";
import "./TeamSection.css";
import { useTranslation } from "react-i18next";

import member1 from "../../Asset/Images/Operator_President_dhanraj.jpeg";
import member2 from "../../Asset/Images/Center Head_Roshani.jpeg";
import membernew from "../../Asset/Images/Mr_Atul_Kamble.jpeg";
import member4 from "../../Asset/Images/Dr_Shruti.jpeg";

const TeamSection = () => {
  const { t } = useTranslation();

  const team = [
    {
      img: member1,
      nameKey: "team.name_dhanraj",
      roleKey: "team.role_president",
      link: "https://wa.me/917066883322",
    },
    {
      img: member2,
      nameKey: "team.name_roshni",
      roleKey: "team.role_manager",
      link: "https://wa.me/message/OB57KHE64DB4H1",
    },
    
    { img: membernew, nameKey: "gb.name_atul", roleKey: "gb.role_advocate", connect: false },
   { img: member4, nameKey: "gb.name_shruti", roleKey: "gb.role_healthcare", connect: false },
  ];

  return (
    <section className="team-modern">
      <h2>{t("team.title")}</h2>

      <div className="team-grid">
        {team.map((member, index) => (
          <div className="team-modern-card" key={index}>
            <div className="team-image-wrapper">
              <img src={member.img} alt={t(member.nameKey)} />
            </div>

            <div className="team-overlay">
              {/* Translated Name */}
              <h3>{t(member.nameKey)}</h3>
              
              {/* Translated Role */}
              <p>{t(member.roleKey)}</p>
              
              {member.link && (
                <a href={member.link} target="_blank" rel="noopener noreferrer" className="team-contact-link">
                   {t('common.contact_now')}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;